import React,{useEffect,useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiClock,FiCopy,FiRotateCcw,FiTrash2,FiX}=FiIcons;
const STORAGE_KEY='amp-questionnaire-versions';

function readVersions() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function QuestionnaireVersionHistory({sections,onRestore,onClose}) {
  const [versions,setVersions]=useState(readVersions);
  const [label,setLabel]=useState('');
  const [confirmDelete,setConfirmDelete]=useState(null);

  useEffect(()=> {
    localStorage.setItem(STORAGE_KEY,JSON.stringify(versions));
  },[versions]);

  const createVersion=()=> {
    const nextVersion=versions.length + 1;
    const snapshot={
      id: Date.now(),
      version: `v${nextVersion}.0`,
      label: label.trim() || `Questionnaire version ${nextVersion}`,
      createdAt: new Date().toLocaleString(),
      sections: JSON.parse(JSON.stringify(sections))
    };
    setVersions((current)=> [snapshot,...current]);
    setLabel('');
  };

  const duplicateVersion=(version)=> {
    setVersions((current)=> [{
      ...version,
      id: Date.now(),
      version: `v${current.length + 1}.0`,
      label: `${version.label} copy`,
      createdAt: new Date().toLocaleString(),
      sections: JSON.parse(JSON.stringify(version.sections))
    },...current]);
  };

  const deleteVersion=(id)=> {
    setVersions((current)=> current.filter((version)=> version.id!==id));
    setConfirmDelete(null);
  };

  return (
    <div className="modal-backdrop">
      <section className="modal-card" style={{width: 'min(720px,100%)'}}>
        <div className="modal-heading">
          <div>
            <span className="eyebrow">Questionnaire snapshots</span>
            <h2>Version history</h2>
          </div>
          <button className="icon-btn" onClick={onClose} aria-label="Close version history">
            <SafeIcon icon={FiX} />
          </button>
        </div>

        <div style={{display: 'flex',gap: 8,margin: '24px 0 18px'}}>
          <input
            value={label}
            onChange={(event)=> setLabel(event.target.value)}
            placeholder="Version note, e.g. Added venue questions"
            style={{flex: 1,minHeight: 43,padding: '0 12px',border: '1px solid var(--line)',borderRadius: 8}}
          />
          <button className="button primary" onClick={createVersion}>
            Save version
          </button>
        </div>

        {versions.length===0 ? (
          <div style={{padding: '32px 18px',color: 'var(--muted)',background: '#fafaf8',borderRadius: 10,textAlign: 'center'}}>
            <SafeIcon icon={FiClock} />
            <p style={{marginTop: 10}}>No saved versions yet. Create a snapshot before making major edits.</p>
          </div>
        ) : (
          <div style={{display: 'grid',gap: 8}}>
            {versions.map((version)=> (
              <div key={version.id} style={{display: 'flex',alignItems: 'center',gap: 12,padding: 14,background: '#fafaf8',border: '1px solid var(--line)',borderRadius: 10}}>
                <div style={{minWidth: 45,color: 'var(--gold-dark)',fontWeight: 800,fontSize: 12}}>
                  {version.version}
                </div>
                <div style={{flex: 1}}>
                  <strong style={{display: 'block',fontSize: 13}}>{version.label}</strong>
                  <small style={{display: 'block',marginTop: 4,color: 'var(--muted)'}}>
                    {version.createdAt} · {version.sections.length} sections
                  </small>
                </div>
                <button className="icon-btn" onClick={()=> duplicateVersion(version)} title="Duplicate version">
                  <SafeIcon icon={FiCopy} />
                </button>
                <button className="icon-btn" onClick={()=> onRestore(version.sections)} title="Restore version">
                  <SafeIcon icon={FiRotateCcw} />
                </button>
                {confirmDelete===version.id ? (
                  <button className="button secondary" onClick={()=> deleteVersion(version.id)}>Confirm</button>
                ) : (
                  <button className="icon-btn danger" onClick={()=> setConfirmDelete(version.id)} title="Delete version">
                    <SafeIcon icon={FiTrash2} />
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default QuestionnaireVersionHistory;